module.exports = __webpack_public_path__ + "static/media/footprint-icon-pet.16fc4a0e.svg";